"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactType = exports.UPDATE_COUTER_PROPOSITION_SUCCESS = exports.UPDATE_COUTER_PROPOSITION_START = exports.UPDATE_COUTER_PROPOSITION_ERROR = exports.TOGGLE_CHAT_PANEL = exports.SET_SELECTED_CONTACT_ID = exports.SEND_MESSAGE_SUCCESS = exports.SEND_MESSAGE_START = exports.SEND_MESSAGE_FAILURE = exports.REMOVE_SELECTED_CONTACT_ID = exports.REMOVE_CHAT = exports.OPEN_MOBILE_CHATS_SIDEBAR = exports.OPEN_CHAT_PANEL = exports.MAKE_PROPOSITION_FROM_CHAT_SUCCESS = exports.MAKE_PROPOSITION_FROM_CHAT_START = exports.MAKE_PROPOSITION_FROM_CHAT_ERROR = exports.MAKE_PROPOSITION_FROM_CHAT = exports.GET_CONTACT_SUCCESS = exports.GET_CONTACT_START = exports.GET_CONTACT_FAILURE = exports.GET_CONTACTS_SUCCESS = exports.GET_CONTACTS_START = exports.GET_CONTACTS_FAILURE = exports.GET_CHAT_SUCCESS = exports.GET_CHAT_START = exports.GET_CHAT_FAILURE = exports.CREATE_CONVERSATION_SUCCESS = exports.CREATE_CONVERSATION_START = exports.CREATE_CONVERSATION_FAILURE = exports.CLOSE_MOBILE_CHATS_SIDEBAR = exports.CLOSE_CHAT_PANEL = exports.CLEAN_CHAT = exports.ADD_TO_CART_AFTER_PROPOSITION_SUCCESS = exports.ADD_TO_CART_AFTER_PROPOSITION_START = exports.ADD_TO_CART_AFTER_PROPOSITION_ERROR = exports.ADD_TO_CART_AFTER_PROPOSITION = exports.ADD_MESSAGE_OF_PROPOSITION = void 0;
exports.default = chatSaga;
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _axios = _interopRequireDefault(require("react-platform-components/dist/axios"));
var _effects = require("redux-saga/effects");
var _config = require("../config");
var _Utils = require("react-platform-components/dist/Utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(getContacts),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(getContact),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(getChat),
  _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(sendMessage),
  _marked5 = /*#__PURE__*/_regeneratorRuntime().mark(createOrFindConversation),
  _marked6 = /*#__PURE__*/_regeneratorRuntime().mark(updateCounterProposition),
  _marked7 = /*#__PURE__*/_regeneratorRuntime().mark(addToCartAfterAcceptingProposition),
  _marked8 = /*#__PURE__*/_regeneratorRuntime().mark(makePropositionFromChat),
  _marked9 = /*#__PURE__*/_regeneratorRuntime().mark(chatSaga);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var contactType = {
  USER: "USER",
  PRODUCT: "PRODUCT"
};
exports.contactType = contactType;
var ADD_MESSAGE_OF_PROPOSITION = "ADD_MESSAGE_OF_PROPOSITION";
exports.ADD_MESSAGE_OF_PROPOSITION = ADD_MESSAGE_OF_PROPOSITION;
var CLEAN_CHAT = 'CLEAN_CHAT';
exports.CLEAN_CHAT = CLEAN_CHAT;
var GET_CHAT_START = 'GET_CHAT_START_';
exports.GET_CHAT_START = GET_CHAT_START;
var GET_CHAT_SUCCESS = 'GET_CHAT_SUCCESS_';
exports.GET_CHAT_SUCCESS = GET_CHAT_SUCCESS;
var GET_CHAT_FAILURE = 'GET_CHAT_FAILURE_';
exports.GET_CHAT_FAILURE = GET_CHAT_FAILURE;
var REMOVE_CHAT = 'REMOVE_CHAT';
exports.REMOVE_CHAT = REMOVE_CHAT;
var SEND_MESSAGE_START = 'SEND_MESSAGE_START';
exports.SEND_MESSAGE_START = SEND_MESSAGE_START;
var SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
exports.SEND_MESSAGE_SUCCESS = SEND_MESSAGE_SUCCESS;
var SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';
exports.SEND_MESSAGE_FAILURE = SEND_MESSAGE_FAILURE;
var GET_CONTACTS_START = 'GET_CONTACTS_START';
exports.GET_CONTACTS_START = GET_CONTACTS_START;
var GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
exports.GET_CONTACTS_SUCCESS = GET_CONTACTS_SUCCESS;
var GET_CONTACTS_FAILURE = 'GET_CONTACTS_FAILURE';
exports.GET_CONTACTS_FAILURE = GET_CONTACTS_FAILURE;
var GET_CONTACT_START = 'GET_CONTACT_START';
exports.GET_CONTACT_START = GET_CONTACT_START;
var GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';
exports.GET_CONTACT_SUCCESS = GET_CONTACT_SUCCESS;
var GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE';
exports.GET_CONTACT_FAILURE = GET_CONTACT_FAILURE;
var SET_SELECTED_CONTACT_ID = 'SET_SELECTED_CONTACT_ID';
exports.SET_SELECTED_CONTACT_ID = SET_SELECTED_CONTACT_ID;
var REMOVE_SELECTED_CONTACT_ID = 'REMOVE_SELECTED_CONTACT_ID';
exports.REMOVE_SELECTED_CONTACT_ID = REMOVE_SELECTED_CONTACT_ID;
var TOGGLE_CHAT_PANEL = 'TOGGLE_CHAT_PANEL';
exports.TOGGLE_CHAT_PANEL = TOGGLE_CHAT_PANEL;
var OPEN_CHAT_PANEL = 'OPEN_CHAT_PANEL';
exports.OPEN_CHAT_PANEL = OPEN_CHAT_PANEL;
var CLOSE_CHAT_PANEL = 'CLOSE_CHAT_PANEL';
exports.CLOSE_CHAT_PANEL = CLOSE_CHAT_PANEL;
var OPEN_MOBILE_CHATS_SIDEBAR = 'OPEN_MOBILE_CHATS_SIDEBAR';
exports.OPEN_MOBILE_CHATS_SIDEBAR = OPEN_MOBILE_CHATS_SIDEBAR;
var CLOSE_MOBILE_CHATS_SIDEBAR = 'CLOSE_MOBILE_CHATS_SIDEBAR';
exports.CLOSE_MOBILE_CHATS_SIDEBAR = CLOSE_MOBILE_CHATS_SIDEBAR;
var UPDATE_COUTER_PROPOSITION_START = 'UPDATE_COUTER_PROPOSITION_START';
exports.UPDATE_COUTER_PROPOSITION_START = UPDATE_COUTER_PROPOSITION_START;
var UPDATE_COUTER_PROPOSITION_SUCCESS = 'UPDATE_COUTER_PROPOSITION_SUCCESS';
exports.UPDATE_COUTER_PROPOSITION_SUCCESS = UPDATE_COUTER_PROPOSITION_SUCCESS;
var UPDATE_COUTER_PROPOSITION_ERROR = 'UPDATE_COUTER_PROPOSITION_ERROR';
exports.UPDATE_COUTER_PROPOSITION_ERROR = UPDATE_COUTER_PROPOSITION_ERROR;
var CREATE_CONVERSATION_START = "CREATE_CONVERSATION_START";
exports.CREATE_CONVERSATION_START = CREATE_CONVERSATION_START;
var CREATE_CONVERSATION_SUCCESS = "CREATE_CONVERSATION_SUCCESS";
exports.CREATE_CONVERSATION_SUCCESS = CREATE_CONVERSATION_SUCCESS;
var CREATE_CONVERSATION_FAILURE = "CREATE_CONVERSATION_FAILURE";
exports.CREATE_CONVERSATION_FAILURE = CREATE_CONVERSATION_FAILURE;
var ADD_TO_CART_AFTER_PROPOSITION = "ADD_TO_CART_AFTER_PROPOSITION";
exports.ADD_TO_CART_AFTER_PROPOSITION = ADD_TO_CART_AFTER_PROPOSITION;
var ADD_TO_CART_AFTER_PROPOSITION_START = "ADD_TO_CART_AFTER_PROPOSITION_START";
exports.ADD_TO_CART_AFTER_PROPOSITION_START = ADD_TO_CART_AFTER_PROPOSITION_START;
var ADD_TO_CART_AFTER_PROPOSITION_SUCCESS = "ADD_TO_CART_AFTER_PROPOSITION_SUCCESS";
exports.ADD_TO_CART_AFTER_PROPOSITION_SUCCESS = ADD_TO_CART_AFTER_PROPOSITION_SUCCESS;
var ADD_TO_CART_AFTER_PROPOSITION_ERROR = "ADD_TO_CART_AFTER_PROPOSITION_ERROR";
exports.ADD_TO_CART_AFTER_PROPOSITION_ERROR = ADD_TO_CART_AFTER_PROPOSITION_ERROR;
var MAKE_PROPOSITION_FROM_CHAT = "MAKE_PROPOSITION_FROM_CHAT";
exports.MAKE_PROPOSITION_FROM_CHAT = MAKE_PROPOSITION_FROM_CHAT;
var MAKE_PROPOSITION_FROM_CHAT_START = "MAKE_PROPOSITION_FROM_CHAT_START";
exports.MAKE_PROPOSITION_FROM_CHAT_START = MAKE_PROPOSITION_FROM_CHAT_START;
var MAKE_PROPOSITION_FROM_CHAT_SUCCESS = "MAKE_PROPOSITION_FROM_CHAT_SUCCESS";
exports.MAKE_PROPOSITION_FROM_CHAT_SUCCESS = MAKE_PROPOSITION_FROM_CHAT_SUCCESS;
var MAKE_PROPOSITION_FROM_CHAT_ERROR = "MAKE_PROPOSITION_FROM_CHAT_ERROR";
exports.MAKE_PROPOSITION_FROM_CHAT_ERROR = MAKE_PROPOSITION_FROM_CHAT_ERROR;
function getContacts(action) {
  var resposne, state, currentUser, contacts;
  return _regeneratorRuntime().wrap(function getContacts$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _axios.default.get("".concat(_config.BASE_API_URL, "conversations?_embed=product.category&_sort=-messages.created_at"), {
            params: action.params
          });
        case 3:
          resposne = _context.sent;
          _context.next = 6;
          return (0, _effects.select)();
        case 6:
          state = _context.sent;
          currentUser = state.auth.user;
          contacts = _lodash.default.map(resposne.data, function (item) {
            var contact = _objectSpread(_objectSpread({}, item), {}, {
              user: _lodash.default.filter(item.users, function (usr) {
                return usr.id.toString() !== currentUser.id.toString();
              })[0]
            });
            delete contact.users;
            return contact;
          });
          action.onSuccess && action.onSuccess();
          _context.next = 12;
          return (0, _effects.put)({
            type: GET_CONTACTS_SUCCESS,
            contacts: contacts
          });
        case 12:
          _context.next = 18;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          _context.next = 18;
          return (0, _effects.put)({
            type: GET_CONTACTS_FAILURE
          });
        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 14]]);
}
function getContact(action) {
  var response, state, currentUser, contacts;
  return _regeneratorRuntime().wrap(function getContact$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return _axios.default.get("".concat(_config.BASE_API_URL, "conversations/").concat(action.id, "?_embed=product.category"), {
            params: action.params
          });
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.select)();
        case 6:
          state = _context2.sent;
          currentUser = state.auth.user;
          contacts = _objectSpread(_objectSpread({}, response.data), {}, {
            user: response.data.users.find(function (usr) {
              return usr.id.toString() !== currentUser.id.toString();
            })
          });
          _context2.next = 11;
          return (0, _effects.put)({
            type: GET_CONTACT_SUCCESS,
            contacts: contacts
          });
        case 11:
          _context2.next = 17;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 17;
          return (0, _effects.put)({
            type: GET_CONTACT_FAILURE
          });
        case 17:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 13]]);
}
function getChat(action) {
  var _action$params, _action$params2, params, response;
  return _regeneratorRuntime().wrap(function getChat$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)({
            type: CLOSE_MOBILE_CHATS_SIDEBAR
          });
        case 2:
          _context3.prev = 2;
          params = action.params || {};
          _context3.next = 6;
          return _axios.default.get("".concat(_config.BASE_API_URL, "messages"), {
            params: params
          });
        case 6:
          response = _context3.sent;
          _context3.next = 9;
          return (0, _effects.put)({
            contactId: action.contactId,
            type: SET_SELECTED_CONTACT_ID
          });
        case 9:
          _context3.next = 11;
          return (0, _effects.put)({
            type: GET_CHAT_SUCCESS,
            chat: _lodash.default.sortBy(response.data, function (message) {
              return (0, _moment.default)(message.created_at);
            }),
            pagination: {
              count: parseInt(response.headers['x-total-count'], 10),
              page: parseInt(((_action$params = action.params) === null || _action$params === void 0 ? void 0 : _action$params._page) || '1', 10),
              perPage: parseInt(((_action$params2 = action.params) === null || _action$params2 === void 0 ? void 0 : _action$params2._per_page) || 20, 10)
            }
          });
        case 11:
          action.onSuccess && action.onSuccess();
          _context3.next = 18;
          break;
        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](2);
          _context3.next = 18;
          return (0, _effects.put)({
            type: GET_CHAT_FAILURE
          });
        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[2, 14]]);
}
function sendMessage(action) {
  var formData, index, _iterator, _step, item, response;
  return _regeneratorRuntime().wrap(function sendMessage$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          formData = new FormData();
          formData.append('conversation', action.conversation);
          formData.append('body', action.message);
          if (action.attachment) {
            index = 0;
            _iterator = _createForOfIteratorHelper(action.attachment);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                item = _step.value;
                formData.append("attachments-".concat(index, "-name"), item);
                index += 1;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          _context4.next = 7;
          return _axios.default.post("".concat(_config.BASE_API_URL, "messages"), formData);
        case 7:
          response = _context4.sent;
          _context4.next = 10;
          return (0, _effects.put)({
            message: _objectSpread({}, response.data),
            type: SEND_MESSAGE_SUCCESS
          });
        case 10:
          action.onSuccess && action.onSuccess();
          _context4.next = 19;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 17;
          return (0, _effects.put)({
            type: SEND_MESSAGE_FAILURE
          });
        case 17:
          _context4.next = 19;
          return (0, _effects.put)({
            type: 'HANDLE_ERROR',
            error: (0, _Utils.handleErrors)(_context4.t0)
          });
        case 19:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 13]]);
}
function createOrFindConversation(action) {
  var model, response;
  return _regeneratorRuntime().wrap(function createOrFindConversation$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          model = {
            conversation_users: [{
              user: action.userId
            }]
          };
          if (action.productId) {
            model.product = action.productId;
          }
          _context5.next = 5;
          return _axios.default.post("".concat(_config.BASE_API_URL).concat(action.productId === null || action.productId === undefined ? "conversations" : "conversation-about-products"), model);
        case 5:
          response = _context5.sent;
          _context5.next = 8;
          return (0, _effects.put)({
            type: CREATE_CONVERSATION_SUCCESS,
            payload: response.data
          });
        case 8:
          _context5.next = 10;
          return (0, _effects.put)({
            type: GET_CHAT_START,
            params: {
              "conversation.id": response.data.id,
              _embed: "user"
            },
            contactId: response.data.id
          });
        case 10:
          _context5.next = 12;
          return (0, _effects.put)({
            type: GET_CONTACT_START,
            id: response.data.id
          });
        case 12:
          _context5.next = 18;
          break;
        case 14:
          _context5.prev = 14;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 18;
          return (0, _effects.put)({
            type: CREATE_CONVERSATION_FAILURE
          });
        case 18:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 14]]);
}
function updateCounterProposition(action) {
  var state, contactId;
  return _regeneratorRuntime().wrap(function updateCounterProposition$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return _axios.default.patch("".concat(_config.BASE_API_URL, "proposition-of-products/").concat(action.itemId), {
            status: action.handleType
          });
        case 3:
          _context6.next = 5;
          return (0, _effects.select)();
        case 5:
          state = _context6.sent;
          contactId = state.chatReducer.selectedContactId;
          _context6.next = 9;
          return (0, _effects.put)({
            type: GET_CHAT_START,
            contactId: contactId,
            params: {
              'conversation.id': contactId,
              _embed: ['user', 'counter_proposition']
            }
          });
        case 9:
          _context6.next = 11;
          return (0, _effects.put)({
            type: UPDATE_COUTER_PROPOSITION_SUCCESS
          });
        case 11:
          _context6.next = 17;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 17;
          return (0, _effects.put)({
            type: UPDATE_COUTER_PROPOSITION_ERROR
          });
        case 17:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 13]]);
}
function addToCartAfterAcceptingProposition(action) {
  var model, response;
  return _regeneratorRuntime().wrap(function addToCartAfterAcceptingProposition$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.put)({
            type: ADD_TO_CART_AFTER_PROPOSITION_START
          });
        case 3:
          model = {
            salable_item_class: 'SalableProduct',
            salable_item_uuid: action.product.uuid
          };
          _context7.next = 6;
          return _axios.default.post("".concat(_config.BASE_API_URL).concat(_config.CART_ITEMS_ENDPOINT), model);
        case 6:
          response = _context7.sent;
          _context7.next = 9;
          return (0, _effects.put)({
            type: ADD_TO_CART_AFTER_PROPOSITION_SUCCESS
          });
        case 9:
          action.onSuccess && action.onSuccess();
          _context7.next = 18;
          break;
        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 16;
          return (0, _effects.put)({
            type: ADD_TO_CART_AFTER_PROPOSITION_ERROR
          });
        case 16:
          _context7.next = 18;
          return (0, _effects.put)({
            type: 'HANDLE_ERROR',
            error: (0, _Utils.handleErrors)(_context7.t0)
          });
        case 18:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 12]]);
}
function makePropositionFromChat(action) {
  return _regeneratorRuntime().wrap(function makePropositionFromChat$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.put)({
            type: MAKE_PROPOSITION_FROM_CHAT_START
          });
        case 3:
          _context8.next = 5;
          return _axios.default.post("".concat(_config.BASE_API_URL, "proposition-of-products"), action.data);
        case 5:
          _context8.next = 7;
          return (0, _effects.put)({
            type: MAKE_PROPOSITION_FROM_CHAT_SUCCESS
          });
        case 7:
          _context8.next = 9;
          return (0, _effects.put)({
            type: ADD_MESSAGE_OF_PROPOSITION,
            message: action.message
          });
        case 9:
          action.onSuccess && action.onSuccess();
          _context8.next = 18;
          break;
        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 16;
          return (0, _effects.put)({
            type: MAKE_PROPOSITION_FROM_CHAT_ERROR
          });
        case 16:
          _context8.next = 18;
          return (0, _effects.put)({
            type: 'HANDLE_ERROR',
            error: (0, _Utils.handleErrors)(_context8.t0)
          });
        case 18:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[0, 12]]);
}
function chatSaga() {
  return _regeneratorRuntime().wrap(function chatSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.all)([(0, _effects.takeEvery)(GET_CONTACTS_START, getContacts), (0, _effects.takeEvery)(GET_CHAT_START, getChat), (0, _effects.takeEvery)(SEND_MESSAGE_START, sendMessage), (0, _effects.takeEvery)(CREATE_CONVERSATION_START, createOrFindConversation), (0, _effects.takeEvery)(GET_CONTACT_START, getContact), (0, _effects.takeEvery)(UPDATE_COUTER_PROPOSITION_START, updateCounterProposition), (0, _effects.takeEvery)(ADD_TO_CART_AFTER_PROPOSITION, addToCartAfterAcceptingProposition), (0, _effects.takeEvery)(MAKE_PROPOSITION_FROM_CHAT, makePropositionFromChat)]);
        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}